import { LocalStorageKey } from '@/constants/shared';
import { useLocalStorage } from 'usehooks-ts';

export const useAuthenticatedLoadingState = () => {
  const [authenticatedLoadingState, setAuthenticatedLoadingState] = useLocalStorage(
    LocalStorageKey.UseAuthenticatedLoadingState + window.location.hostname + import.meta.env.MODE,
    false,
  );
  return {
    authenticatedLoadingState,
    setAuthenticatedLoadingState,
  };
};
